// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file bay_session.proto (package evenplay.bay_session.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Heartbeat, PlayerState } from "./bay_session_shared_pb";
import { file_bay_session_shared } from "./bay_session_shared_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bay_session.proto.
 */
export const file_bay_session: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_bay_session_shared]);

/**
 * SessionStateUpdate is published to bay_session.state.station.{station_id}
 * on every mutation of the bay session. Carries the full state snapshot per
 * the full-snapshot property in spec §13.3 — subscribers can apply the
 * latest payload they have without needing to "replay" missed sequences.
 *
 * @generated from message evenplay.bay_session.v1.SessionStateUpdate
 */
export type SessionStateUpdate = Message<"evenplay.bay_session.v1.SessionStateUpdate"> & {
  /**
   * Broker-assigned JetStream stream sequence (§13.3 amendment 2026-05-14).
   * Publishers leave this unset; the package fills it from
   * nats.Msg.Metadata().Sequence.Stream on the subscriber side before
   * dispatching to the handler. NOT used for causal dedupe — see
   * db_version below; broker sequence retains only the gap-accounting
   * role on the consumer side.
   *
   * @generated from field: int64 sequence = 1;
   */
  sequence: bigint;

  /**
   * What triggered the publish — see spec §13.3 table.
   *
   * @generated from field: evenplay.bay_session.v1.SessionStateReason reason = 2;
   */
  reason: SessionStateReason;

  /**
   * Server clock when the publish was emitted by the producing pod.
   * Independent of broker sequencing.
   *
   * @generated from field: google.protobuf.Timestamp sent_at = 3;
   */
  sentAt?: Timestamp;

  /**
   * Station whose state this snapshot describes.
   *
   * @generated from field: int64 station_id = 4;
   */
  stationId: bigint;

  /**
   * Per-stream liveness signal emitted by the StreamSessionState server.
   * When this field is set, the message is a heartbeat: reason and
   * state_snapshot are empty / zero-valued; clients should treat the
   * message as "stream is alive" but apply no state update. The carried
   * Heartbeat.sequence echoes the most recent real-message sequence the
   * server has observed for this stream so clients can fall back to
   * GetSessionState if they detect drift. SMG-4191: the Heartbeat also
   * carries the causal (db_version, sub_sequence, station_id) of the most
   * recent state frame emitted on this stream — the watermark consumers
   * actually dedupe with — see the Heartbeat message. Heartbeats are
   * emitted on a per-stream cadence by the bay-session pod; they are NOT
   * broker-published, so subscribers consuming the raw JetStream subject
   * never see them.
   *
   * @generated from field: optional evenplay.bay_session.v1.Heartbeat heartbeat = 5;
   */
  heartbeat?: Heartbeat;

  /**
   * Monotonic DB-version watermark of the underlying bay_session_state
   * row at publish time (BSA-FU-XPOD-ORDERING, 2026-05-21). Encodes
   * bay_session_state.updated_at as epoch microseconds. Producers MUST
   * set this on every emit so subscribers can order frames by their
   * causal source (the row UPDATE) rather than by JetStream broker
   * sequence — across two bay-session replicas serving the same station,
   * the FOR UPDATE row lock causally serialises commits but the
   * post-commit, unlocked Publish call can reach the broker in reverse
   * commit order. The consumer dedupes on db_version <= lastDelivered
   * (drop stale) so the older causal state cannot overwrite the newer
   * one even when the broker delivers messages in inverted order.
   *
   * Field is unset (zero) on heartbeats; the consumer's drain loop
   * exempts heartbeats from the dedup test by virtue of pulling them
   * from a different path (sendTargetHeartbeat, not the broker buffer).
   * Initial-snapshot frames carry the snapshot's source UpdatedAt so
   * subsequent live frames at the same db_version are correctly
   * recognised as duplicates of the snapshot baseline.
   *
   * @generated from field: int64 db_version = 6;
   */
  dbVersion: bigint;

  /**
   * SMG-3390: monotonic tiebreaker WITHIN a single db_version. One commit
   * (one db_version bump) can publish multiple causally-distinct frames —
   * e.g. a bet settle followed by the next-player activation, or any of the
   * rotation / wager-mode / leave / auto-continue / tier-change sites that
   * emit a trailing frame from the same row UPDATE. All carry the same
   * db_version, and the legacy dedup (db_version <= lastDelivered) wrongly
   * dropped every frame after the first. Producers stamp a process-monotonic
   * counter here so the consumer orders same-db_version frames by
   * (db_version, sub_sequence) and delivers each distinct one. Unset (0) on
   * heartbeats and on legacy producers that predate this field; the consumer
   * treats 0 as "no tiebreak" and falls back to the db_version-only rule, so
   * the wire change is backward-compatible. Initial-snapshot frames already
   * fold in every mutation up to their db_version, so the consumer seeds its
   * baseline sub_sequence to the max sentinel — every same-or-lower
   * db_version live frame after a snapshot stays correctly deduped.
   *
   * @generated from field: int64 sub_sequence = 7;
   */
  subSequence: bigint;

  /**
   * Placeholder for the full state snapshot. BSA-3-2 will replace this
   * bytes field with a typed BaySessionState message.
   *
   * @generated from field: bytes state_snapshot = 100;
   */
  stateSnapshot: Uint8Array;
};

/**
 * Describes the message evenplay.bay_session.v1.SessionStateUpdate.
 * Use `create(SessionStateUpdateSchema)` to create a new message.
 */
export const SessionStateUpdateSchema: GenMessage<SessionStateUpdate> = /*@__PURE__*/
  messageDesc(file_bay_session, 0);

/**
 * PlayerStateUpdate is published to bay_session.state.player.{user_id} on
 * every mutation that affects a specific player (§13.9). Same snapshot
 * semantics as SessionStateUpdate.
 *
 * @generated from message evenplay.bay_session.v1.PlayerStateUpdate
 */
export type PlayerStateUpdate = Message<"evenplay.bay_session.v1.PlayerStateUpdate"> & {
  /**
   * Broker-assigned JetStream stream sequence — same semantics as
   * SessionStateUpdate.sequence (gap-accounting only, not used for
   * causal dedup; see db_version).
   *
   * @generated from field: int64 sequence = 1;
   */
  sequence: bigint;

  /**
   * What triggered the publish.
   *
   * @generated from field: evenplay.bay_session.v1.PlayerStateReason reason = 2;
   */
  reason: PlayerStateReason;

  /**
   * Server clock when the publish was emitted.
   *
   * @generated from field: google.protobuf.Timestamp sent_at = 3;
   */
  sentAt?: Timestamp;

  /**
   * User this snapshot describes.
   *
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * Per-stream liveness signal — same semantics as
   * SessionStateUpdate.heartbeat. Set means the message is a heartbeat
   * and state / reason are empty.
   *
   * @generated from field: optional evenplay.bay_session.v1.Heartbeat heartbeat = 5;
   */
  heartbeat?: Heartbeat;

  /**
   * Monotonic DB-version watermark — same encoding and ordering rule as
   * SessionStateUpdate.db_version (epoch microseconds of the source
   * bay_session_state.updated_at). Per-player publishes derive the
   * version from the same station-level row UPDATE that the station
   * publish reads, so a subscriber listening to both streams sees both
   * channels move forward together against a single monotonic source.
   *
   * @generated from field: int64 db_version = 6;
   */
  dbVersion: bigint;

  /**
   * SMG-3390: monotonic tiebreaker WITHIN a single db_version — same
   * semantics as SessionStateUpdate.sub_sequence. Per-player publishes derive
   * db_version from the same station row UPDATE that the station publish
   * reads, so a settle frame and the trailing activation frame for one player
   * share a db_version; this field lets the consumer deliver both instead of
   * dropping the second. Unset (0) on heartbeats / legacy producers (falls
   * back to the db_version-only rule). Snapshot baseline seeds to the max
   * sentinel so post-snapshot same-db_version frames stay deduped.
   *
   * @generated from field: int64 sub_sequence = 7;
   */
  subSequence: bigint;

  /**
   * Typed per-player state snapshot. Wire-compatible with the legacy
   * bytes field at the same field number: protobuf encodes both
   * length-delimited messages and bytes identically on the wire, so an
   * older subscriber that previously decoded bytes will fail to parse a
   * PlayerState payload — the bytes-path consumer in this repo never
   * shipped to production (BSA-3-2 introduced PlayerStateUpdate as a
   * placeholder; the bay-session pod is the only producer / consumer).
   * BSA-4-2 replaces the placeholder with the typed message.
   *
   * @generated from field: evenplay.bay_session.v1.PlayerState state = 100;
   */
  state?: PlayerState;
};

/**
 * Describes the message evenplay.bay_session.v1.PlayerStateUpdate.
 * Use `create(PlayerStateUpdateSchema)` to create a new message.
 */
export const PlayerStateUpdateSchema: GenMessage<PlayerStateUpdate> = /*@__PURE__*/
  messageDesc(file_bay_session, 1);

/**
 * SessionStateReason mirrors the bay-wide reasons enumerated in spec
 * §13.3. Only the reasons surfaced by callers of this package need to
 * exist; BSA-3-2 can extend without renumbering.
 *
 * @generated from enum evenplay.bay_session.v1.SessionStateReason
 */
export enum SessionStateReason {
  /**
   * @generated from enum value: SESSION_STATE_REASON_UNSPECIFIED = 0;
   */
  SESSION_STATE_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_PLAYER_JOINED = 1;
   */
  SESSION_PLAYER_JOINED = 1,

  /**
   * @generated from enum value: SESSION_PLAYER_LEFT = 2;
   */
  SESSION_PLAYER_LEFT = 2,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_CHANGED = 3;
   */
  SESSION_PLAY_MODE_CHANGED = 3,

  /**
   * @generated from enum value: SESSION_ROTATION_ADVANCED = 4;
   */
  SESSION_ROTATION_ADVANCED = 4,

  /**
   * @generated from enum value: SESSION_ROTATION_SKIPPED = 5;
   */
  SESSION_ROTATION_SKIPPED = 5,

  /**
   * @generated from enum value: SESSION_ROTATION_RESET = 6;
   */
  SESSION_ROTATION_RESET = 6,

  /**
   * @generated from enum value: SESSION_ACTIVE_PLAYER_CHANGED = 7;
   */
  SESSION_ACTIVE_PLAYER_CHANGED = 7,

  /**
   * @generated from enum value: SESSION_WAGER_MODE_CHANGED = 8;
   */
  SESSION_WAGER_MODE_CHANGED = 8,

  /**
   * @generated from enum value: SESSION_BELOW_MINIMUM_WAGER = 9;
   */
  SESSION_BELOW_MINIMUM_WAGER = 9,

  /**
   * ROTATION landed on a paused player (wager_mode == NONE), including
   * chain-skip exhausting the roster (active became nil). Subscribers
   * use this to distinguish a paused-active surface from a normal
   * SESSION_ROTATION_SKIPPED advance.
   *
   * @generated from enum value: SESSION_PLAYER_WAGER_MODE_NONE = 10;
   */
  SESSION_PLAYER_WAGER_MODE_NONE = 10,

  /**
   * @generated from enum value: SESSION_CONFIRMATION_SETTINGS_CHANGED = 11;
   */
  SESSION_CONFIRMATION_SETTINGS_CHANGED = 11,

  /**
   * @generated from enum value: SESSION_BET_ACCEPTED = 12;
   */
  SESSION_BET_ACCEPTED = 12,

  /**
   * @generated from enum value: SESSION_BET_COMMITTED = 13;
   */
  SESSION_BET_COMMITTED = 13,

  /**
   * @generated from enum value: SESSION_BET_SETTLED = 14;
   */
  SESSION_BET_SETTLED = 14,

  /**
   * @generated from enum value: SESSION_BET_REFUNDED = 15;
   */
  SESSION_BET_REFUNDED = 15,

  /**
   * @generated from enum value: SESSION_FRS_PLAYER_DETECTED = 16;
   */
  SESSION_FRS_PLAYER_DETECTED = 16,

  /**
   * @generated from enum value: SESSION_FRS_MULTI_PLAYER = 17;
   */
  SESSION_FRS_MULTI_PLAYER = 17,

  /**
   * @generated from enum value: SESSION_FRS_NO_PLAYER = 18;
   */
  SESSION_FRS_NO_PLAYER = 18,

  /**
   * BSA-FU-NATS-PARTITION-RECOVERY: the publish-recovery worker re-emits
   * a fresh DB-sourced snapshot after detecting a stale row whose
   * hot-path publish was dropped (broker partition, crash mid-publish,
   * etc.). Subscribers dedupe on db_version (BSA-FU-XPOD-ORDERING), so
   * the wire-level effect is identical to the originating reason; the
   * distinct enum value exists for operator log/metric clarity, NOT to
   * change subscriber behaviour.
   *
   * @generated from enum value: SESSION_RESYNC = 19;
   */
  SESSION_RESYNC = 19,

  /**
   * The subject station saw a SetAutoContinue write — a roster member
   * flipped their auto_continue_enabled flag or changed their pinned
   * wager amount. Subscribers re-render the affected SessionPlayer
   * tile; the snapshot's SessionPlayer entry carries the new
   * auto_continue_* fields.
   *
   * @generated from enum value: SESSION_AUTO_CONTINUE_CHANGED = 20;
   */
  SESSION_AUTO_CONTINUE_CHANGED = 20,

  /**
   * SMG-3077: a roster member's UserTier just changed — typically
   * because a future admin/compliance RPC flipped their kyc_status
   * (e.g. KYC outcome arrived, or the forfeiture cascade demoted an
   * Adult-Unconfirmed to Minor on age verification). The snapshot's
   * SessionPlayer.allowed_wager_modes will reflect the new tier; the
   * mobile re-renders the wager-mode picker so the player can't
   * submit a now-disallowed mode. No call site triggers this yet;
   * the wire surface lands here so consumers can react when the
   * forfeiture cascade ticket adds the trigger.
   *
   * @generated from enum value: SESSION_PLAYER_TIER_CHANGED = 21;
   */
  SESSION_PLAYER_TIER_CHANGED = 21,

  /**
   * SMG-3149 / SMG-4001: a roster member's readiness gate changed via
   * SetAccountLock or ConfirmReadyToSwing. SessionPlayer.is_idle
   * reflects the durable timeout gate, while SessionPlayer.readiness
   * carries the aggregate post-write readiness result. Subscribers
   * re-render the affected player tile so kiosk + mobile UIs surface
   * the new gate state. The historical enum name is retained for wire
   * compatibility; operators inspect the projected SessionPlayer
   * fields to identify the visible outcome.
   *
   * @generated from enum value: SESSION_LOCK_STATUS_CHANGED = 22;
   */
  SESSION_LOCK_STATUS_CHANGED = 22,

  /**
   * SMG-3280: a player was force-joined to the bay via AdminJoinPlayer
   * (simulator/support-initiated, bypassing business gates). Semantically a
   * join — the snapshot carries the new roster exactly as SESSION_PLAYER_JOINED
   * would, and subscribers MUST treat it identically (they dedupe on db_version
   * and re-render from the snapshot, like SESSION_RESYNC). The distinct value
   * exists only so operators/metrics can tell a forced join from an organic one;
   * it is NOT a behaviour-change signal.
   *
   * @generated from enum value: SESSION_PLAYER_ADMIN_JOINED = 23;
   */
  SESSION_PLAYER_ADMIN_JOINED = 23,

  /**
   * SMG-3243: the rotation turn-timeout sweeper expired the current
   * awaiting-confirmation turn (NOW() - awaiting_confirmation_set_at
   * > turn_timeout_seconds). The accompanying SessionState carries the
   * post-resolution rotation projection: confirmation cleared, the
   * active player's confirmation_outcome flipped to TIMED_OUT, and the
   * active slot advanced / cleared per rotation rules. Subscribers
   * re-render the "Up next" / countdown UI and surface the timeout
   * outcome in the player tile.
   *
   * @generated from enum value: SESSION_TURN_TIMED_OUT = 24;
   */
  SESSION_TURN_TIMED_OUT = 24,

  /**
   * SMG-3345: the per-shot confirmation handshake armed a bet
   * (bay_session_state.shot_armed_bet_id set) — via the player gesture
   * RespondToConfirmation(accepted=true) outside ROTATION, or the
   * test/simulator AdminArmShot primitive. The accompanying SessionState
   * carries the post-arm projection (shot_armed_bet_id populated) so the
   * kiosk can flip its shot-ready UI. Like SESSION_PLAYER_ADMIN_JOINED,
   * this is an operator/metrics distinction, not a behaviour-change
   * signal: subscribers dedupe on db_version and re-render from the
   * snapshot. Used instead of SESSION_ROTATION_ADVANCED for arms that did
   * NOT advance the rotation cursor.
   *
   * @generated from enum value: SESSION_SHOT_ARMED = 25;
   */
  SESSION_SHOT_ARMED = 25,

  /**
   * SMG-3174 Wave D: the bay's resolved capability set was recomputed and
   * re-projected onto station_capability_set (device check-in / address change
   * / admin recompute). Subscribers re-read the LOCAL projection — bay-session
   * never resolves live (design §8). Published by smg-core post-projection-
   * write, best-effort (a missed frame is recovered by the next recompute's
   * supersedure). The snapshot carries no per-capability payload here; the
   * capability set lives in the projection bay-session reads.
   * Renumbered 22->26 on the main merge: main's lock-status/admin-join/turn-
   * timeout/shot-armed reasons claimed 22-25, so this capability reason moves
   * to the next free slot. The Go/TS enums reference it by NAME, so renumbering
   * is wire-safe for in-repo consumers; no persisted value depends on 22.
   *
   * @generated from enum value: SESSION_CAPABILITY_CHANGED = 26;
   */
  SESSION_CAPABILITY_CHANGED = 26,

  /**
   * SMG-3046: the idle-eviction sweeper ejected a SINGLE player whose
   * per-player idle clock aged past the 30-min individual-eject timeout.
   * The accompanying SessionState reflects the post-removal roster (the
   * idle player's row is gone). The idle player's open bet is intentionally
   * LEFT OPEN (no refund) and re-surfaces on rejoin — distinct from the
   * RemovePlayer cascade-refund flow (SESSION_PLAYER_LEFT). Companion
   * per-user reason: PLAYER_IDLE_EJECTED.
   *
   * @generated from enum value: SESSION_PLAYER_IDLE_EJECTED = 27;
   */
  SESSION_PLAYER_IDLE_EJECTED = 27,

  /**
   * SMG-3046: the idle-eviction sweeper ejected EVERY player because the
   * session-level idle clock aged past the 15-min whole-session timeout
   * (no activity from anyone). The accompanying SessionState reflects the
   * now-empty bay. Open bets are LEFT OPEN (no refund) and re-surface on
   * rejoin. Per-user PLAYER_IDLE_EJECTED frames fan out to each ejected
   * player.
   *
   * @generated from enum value: SESSION_IDLE_TIMEOUT_EJECTED = 28;
   */
  SESSION_IDLE_TIMEOUT_EJECTED = 28,

  /**
   * SMG-3046: the idle-eviction sweeper autoskipped the ROTATION active
   * player whose per-player idle clock aged past the 5-min active-player
   * autoskip timeout. The turn advanced via the chain-skip machinery; the
   * autoskipped player STAYS on the roster (this is NOT an eviction) and
   * their open bet is left untouched. Companion per-user reason:
   * PLAYER_AUTOSKIPPED.
   *
   * @generated from enum value: SESSION_PLAYER_AUTOSKIPPED = 29;
   */
  SESSION_PLAYER_AUTOSKIPPED = 29,

  /**
   * SMG-3455: the ROTATION active player could not fund their next wager
   * (insufficient available balance) and had no points fallback (the station
   * offers no points currency, or their points balance is also insufficient),
   * so the rotation advanced past them to the next player. The accompanying
   * SessionState carries the post-advance rotation projection (the new active
   * player). The kiosk surfaces "<name> has insufficient funds — moved to the
   * next player in the rotation." Companion per-user reason:
   * PLAYER_INSUFFICIENT_FUNDS. Distinct from SESSION_ROTATION_SKIPPED (a
   * voluntary skip / chain-skip past a paused player) so operators can tell a
   * funds-driven skip from an intentional one.
   *
   * @generated from enum value: SESSION_PLAYER_INSUFFICIENT_FUNDS = 30;
   */
  SESSION_PLAYER_INSUFFICIENT_FUNDS = 30,

  /**
   * TRN-3: the station's active player auto-entered TOURNAMENT play mode
   * (the active player has an in-progress tournament whose onboarding is
   * complete). The accompanying SessionState carries play_mode=TOURNAMENT,
   * the remembered base_play_mode, and tournament_id. Subscribers surface
   * the tournament HUD / leaderboard; the base mode is restored (and
   * SESSION_TOURNAMENT_EXITED published) when participation completes.
   * Renumbered 26->30->31 across main merges (capability/idle-eviction
   * claimed 26-29, SMG-3455 claimed 30). The Go/TS enums reference it by
   * NAME, so the renumber is wire-safe for in-repo consumers.
   *
   * @generated from enum value: SESSION_TOURNAMENT_ENTERED = 31;
   */
  SESSION_TOURNAMENT_ENTERED = 31,

  /**
   * TRN-3: the station left TOURNAMENT play mode and restored base_play_mode
   * (participation completed, the tournament left the PLAYING state, or the
   * active player changed to one without that tournament). The accompanying
   * SessionState carries play_mode=base_play_mode with tournament_id cleared.
   *
   * @generated from enum value: SESSION_TOURNAMENT_EXITED = 32;
   */
  SESSION_TOURNAMENT_EXITED = 32,

  /**
   * SMG-3330: the station's active_messages projection changed (a
   * notification message was created / acked / taken down / expired for
   * this station or a broadcast). Labels a message-triggered re-snapshot
   * so subscribers can distinguish it from a state mutation; the
   * SessionState carries the updated active_messages list.
   *
   * @generated from enum value: SESSION_MESSAGES_CHANGED = 33;
   */
  SESSION_MESSAGES_CHANGED = 33,

  /**
   * SMG-4001: MarkPlayerTimedOut persisted the subject player's durable
   * timeout gate and cleared the station's active-player pointer in the
   * same atomic mutation. The accompanying snapshot carries both changes.
   * This reason prevents consumers from having to choose between treating
   * the frame as a readiness change or an active-player transition.
   *
   * @generated from enum value: SESSION_PLAYER_TIMED_OUT = 34;
   */
  SESSION_PLAYER_TIMED_OUT = 34,
}

/**
 * Describes the enum evenplay.bay_session.v1.SessionStateReason.
 */
export const SessionStateReasonSchema: GenEnum<SessionStateReason> = /*@__PURE__*/
  enumDesc(file_bay_session, 0);

/**
 * PlayerStateReason mirrors the per-user reasons in spec §13.9. The
 * PLAYER_* prefix distinguishes the per-user channel from the station-
 * wide reasons; the broker subjects already separate the two streams,
 * so there is no overlap of meaning.
 *
 * BSA-4-2 extension (8-15): roster + active-player + skip + FRS reasons
 * surfaced by the Group-3 handlers. Each new reason matches a station-
 * level reason (SESSION_PLAYER_JOINED / SESSION_PLAYER_LEFT / ...) so
 * subscribers can correlate the two channels at the reason layer.
 *
 * @generated from enum evenplay.bay_session.v1.PlayerStateReason
 */
export enum PlayerStateReason {
  /**
   * @generated from enum value: PLAYER_STATE_REASON_UNSPECIFIED = 0;
   */
  PLAYER_STATE_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAYER_BET_ACCEPTED = 1;
   */
  PLAYER_BET_ACCEPTED = 1,

  /**
   * @generated from enum value: PLAYER_BET_COMMITTED = 2;
   */
  PLAYER_BET_COMMITTED = 2,

  /**
   * @generated from enum value: PLAYER_BET_SETTLED = 3;
   */
  PLAYER_BET_SETTLED = 3,

  /**
   * @generated from enum value: PLAYER_BET_REFUNDED = 4;
   */
  PLAYER_BET_REFUNDED = 4,

  /**
   * @generated from enum value: PLAYER_BELOW_MINIMUM_WAGER = 5;
   */
  PLAYER_BELOW_MINIMUM_WAGER = 5,

  /**
   * @generated from enum value: PLAYER_WAGER_MODE_CHANGED = 6;
   */
  PLAYER_WAGER_MODE_CHANGED = 6,

  /**
   * @generated from enum value: PLAYER_CONFIRMATION_SETTINGS_CHANGED = 7;
   */
  PLAYER_CONFIRMATION_SETTINGS_CHANGED = 7,

  /**
   * The subject user just joined a station's roster.
   *
   * @generated from enum value: PLAYER_JOINED = 8;
   */
  PLAYER_JOINED = 8,

  /**
   * The subject user just left (or was removed from) a station's
   * roster. current_station_id in the published PlayerState carries 0.
   *
   * @generated from enum value: PLAYER_LEFT = 9;
   */
  PLAYER_LEFT = 9,

  /**
   * The subject user just became the active player at their station.
   *
   * @generated from enum value: PLAYER_ACTIVATED = 10;
   */
  PLAYER_ACTIVATED = 10,

  /**
   * The subject user just lost active-player status (a different
   * player became active or the active slot cleared).
   *
   * @generated from enum value: PLAYER_DEACTIVATED = 11;
   */
  PLAYER_DEACTIVATED = 11,

  /**
   * The subject user just set their one-shot skip_next_turn flag
   * (registered intent to be skipped on their next scheduled turn).
   *
   * @generated from enum value: PLAYER_SKIP_FLAG_SET = 12;
   */
  PLAYER_SKIP_FLAG_SET = 12,

  /**
   * The subject user was skipped by the rotation iteration (either
   * they consumed their skip_next_turn flag or the chain-skip
   * advanced past them).
   *
   * @generated from enum value: PLAYER_TURN_SKIPPED = 13;
   */
  PLAYER_TURN_SKIPPED = 13,

  /**
   * The FRS detection pipeline identified the subject user at a
   * station; the user's bay-session activation is wager-eligible.
   *
   * @generated from enum value: PLAYER_FRS_DETECTED = 14;
   */
  PLAYER_FRS_DETECTED = 14,

  /**
   * The subject user landed in an "active but paused" state
   * (wager_mode == NONE while holding the active slot). The UI
   * typically prompts the user to pick a wager currency.
   *
   * PLAYER_WAGER_CURRENCY_UNAVAILABLE is the follow-up for a successful
   * jurisdiction remint (REAL_MONEY denied, points pin succeeded). The
   * dead-end (no points token) still uses this reason: that player is
   * NOT paused (wager_mode is still MONEY or POINTS) and is distinct
   * from PLAYER_INSUFFICIENT_FUNDS (the player is solvent). Subscribers
   * must not treat this reason as "wager_mode == NONE" exclusively.
   *
   * @generated from enum value: PLAYER_WAGER_MODE_NONE = 15;
   */
  PLAYER_WAGER_MODE_NONE = 15,

  /**
   * The subject user just toggled their autoplay flag (on/off) or
   * changed the pinned per-user wager amount via SetAutoContinue.
   * The accompanying SessionPlayer carries the new auto_continue_*
   * fields.
   *
   * @generated from enum value: PLAYER_AUTO_CONTINUE_CHANGED = 16;
   */
  PLAYER_AUTO_CONTINUE_CHANGED = 16,

  /**
   * SMG-3077: the subject user's UserTier just changed — the per-user
   * counterpart to SESSION_PLAYER_TIER_CHANGED. The mobile reading
   * StreamPlayerState reacts to this by re-rendering the wager-mode
   * picker (allowed_wager_modes on the accompanying SessionPlayer
   * reflects the new tier) and, on a demotion to MINOR / GUEST /
   * ADULT_KYC_FAILED, by hiding any deposit / withdraw buttons.
   *
   * @generated from enum value: PLAYER_TIER_CHANGED = 17;
   */
  PLAYER_TIER_CHANGED = 17,

  /**
   * SMG-3136 (v1.1 A4): the subject user just joined a NEW station while
   * already a member of a different station; the prior-station roster
   * row was evicted in lockstep with the new join. The published
   * PlayerState carries current_station_id = <new station> so the
   * mobile UI can drop any prior-bay state (active bet card, rotation
   * banner) and resync against the new bay. The prior bay separately
   * emits SESSION_PLAYER_LEFT on its station subject so any kiosk /
   * station subscriber sees the eviction in the same beat.
   *
   * NOTE: PLAYER_LEFT is reserved for explicit LeaveSession /
   * RemovePlayer flows where current_station_id transitions to 0 (the
   * player is in NO station). EVICTED is the cross-bay relocation
   * variant: current_station_id transitions FROM the prior station's
   * id TO the new station's id, without ever being 0.
   *
   * @generated from enum value: PLAYER_SESSION_EVICTED = 18;
   */
  PLAYER_SESSION_EVICTED = 18,

  /**
   * SMG-3149 / SMG-4001: the subject user's readiness gate changed via
   * SetAccountLock or ConfirmReadyToSwing. The accompanying PlayerState
   * carries a SessionPlayer whose is_idle reflects the durable timeout
   * gate and whose readiness contains the aggregate post-write result.
   * StreamPlayerState re-renders the Ready UI from those projections.
   * The historical enum name is retained for wire compatibility;
   * consumers inspect the SessionPlayer fields to identify the visible
   * outcome.
   *
   * @generated from enum value: PLAYER_LOCK_STATUS_CHANGED = 19;
   */
  PLAYER_LOCK_STATUS_CHANGED = 19,

  /**
   * SMG-3150 (v1.1 E1): the subject user just completed their free-play
   * wagering requirement — engine projection
   * (smg_user_details.completed_free_play_count) crossed
   * smg_user_details.free_play_count from below. The accompanying
   * PlayerState carries the updated SessionPlayer with
   * completed_free_play_count >= free_play_count and is_new_player=false.
   * The mobile reacts by rendering a celebration animation. Fired at
   * most once per (station, user) per session — bay-session persists a
   * bay_session_players.free_play_turnover_announced flag so the
   * milestone fires exactly once even under JetStream redelivery or
   * multi-pod fan-out.
   *
   * @generated from enum value: PLAYER_FREE_PLAY_TURNED_OVER = 20;
   */
  PLAYER_FREE_PLAY_TURNED_OVER = 20,

  /**
   * SMG-3243: the rotation turn-timeout sweeper expired the subject
   * user's awaiting-confirmation turn. The accompanying PlayerState
   * carries confirmation_outcome=TIMED_OUT on the SessionPlayer entry;
   * the mobile reacts by hiding the "Confirm your turn" prompt,
   * surfacing the timeout outcome on the player tile, and re-rendering
   * the rotation banner against the post-resolution active player.
   * Companion station-level reason: SESSION_TURN_TIMED_OUT.
   *
   * @generated from enum value: PLAYER_TURN_TIMED_OUT = 21;
   */
  PLAYER_TURN_TIMED_OUT = 21,

  /**
   * SMG-3046: the idle-eviction sweeper ejected the subject user — either
   * by the 30-min individual-eject rule (their own idle clock) or by the
   * 15-min whole-session rule (no activity from anyone). The published
   * PlayerState carries current_station_id = 0 (the player is in NO
   * station, like PLAYER_LEFT). Distinct from PLAYER_LEFT in that the
   * ejection is timer-driven and the player's open bet is LEFT OPEN (no
   * refund) — it re-surfaces on rejoin. Companion station-level reasons:
   * SESSION_PLAYER_IDLE_EJECTED / SESSION_IDLE_TIMEOUT_EJECTED.
   *
   * @generated from enum value: PLAYER_IDLE_EJECTED = 22;
   */
  PLAYER_IDLE_EJECTED = 22,

  /**
   * SMG-3046: the subject user's ROTATION turn was autoskipped by the
   * idle-eviction sweeper (5-min active-player autoskip). The player STAYS
   * on the roster (NOT an eviction); the rotation advanced past them and
   * their open bet is left untouched. The accompanying PlayerState shows
   * the player deactivated (a different player is now active). Companion
   * station-level reason: SESSION_PLAYER_AUTOSKIPPED.
   *
   * @generated from enum value: PLAYER_AUTOSKIPPED = 23;
   */
  PLAYER_AUTOSKIPPED = 23,

  /**
   * SMG-3455: the subject player's next real-money wager could not be funded
   * (insufficient available balance for the pinned real-money currency) and
   * bay-session auto-switched their next_wager_currency to the station's
   * points currency so play can continue. The accompanying PlayerState carries
   * the new next_wager_currency on the SessionPlayer. The mobile reacts by
   * surfacing the "we've moved you to Points" banner driven by the SERVER
   * decision (not the client-side USD<$5 heuristic) and re-rendering the
   * wager-currency selector against the new currency. Jurisdiction remint
   * (REAL_MONEY denied, player is solvent) uses PLAYER_WAGER_CURRENCY_UNAVAILABLE
   * instead — do not surface this as an insufficient-funds banner there.
   *
   * @generated from enum value: PLAYER_MOVED_TO_POINTS_INSUFFICIENT_FUNDS = 24;
   */
  PLAYER_MOVED_TO_POINTS_INSUFFICIENT_FUNDS = 24,

  /**
   * SMG-3455: the subject player cannot fund their next wager and no points
   * fallback is available (the station offers no points currency, or the
   * player's points balance is also insufficient). No new bet was minted. The
   * mobile reacts by surfacing the insufficient-funds banner ("you're out of
   * funds to keep playing"). In ROTATION the rotation has advanced past this
   * player (companion station reason SESSION_PLAYER_INSUFFICIENT_FUNDS).
   *
   * @generated from enum value: PLAYER_INSUFFICIENT_FUNDS = 25;
   */
  PLAYER_INSUFFICIENT_FUNDS = 25,

  /**
   * TRN-BSA: the subject player is being offered a tournament to join —
   * a peer at their station just entered TOURNAMENT mode (TRN-7). The
   * accompanying PlayerState carries a non-nil tournament_join_offer
   * (tournament_id only) on exactly this one publish; the mobile reacts
   * by fetching tournament metadata once (TRN-1's metadata RPC) and
   * rendering the join pop-up. One-shot / edge-triggered — see the
   * tournament_join_offer field docstring.
   * Renumbered 22->24->26 across main merges (idle-eviction claimed 22-23,
   * SMG-3455 claimed 24-25). The Go/TS enums reference it by NAME, so the
   * renumber is wire-safe for in-repo consumers.
   *
   * @generated from enum value: PLAYER_TOURNAMENT_JOIN_OFFERED = 26;
   */
  PLAYER_TOURNAMENT_JOIN_OFFERED = 26,

  /**
   * SMG-3330: the subject's active_messages projection changed (a
   * notification message was created / acked / taken down / expired for
   * this player or a broadcast). Labels a message-triggered re-snapshot
   * so subscribers can distinguish it from a state mutation; the
   * PlayerState carries the updated active_messages list.
   *
   * @generated from enum value: PLAYER_MESSAGES_CHANGED = 27;
   */
  PLAYER_MESSAGES_CHANGED = 27,

  /**
   * SMG-3396: the subject's claimed wager category has no legal currency at
   * this bay (typically REAL_MONEY_GAMING denied with wager_mode=MONEY) and
   * bay-session auto-switched their next wager to the station's points
   * currency so play can continue. Distinct from
   * PLAYER_MOVED_TO_POINTS_INSUFFICIENT_FUNDS: the player is solvent; the
   * bay cannot take USD. The accompanying PlayerState carries the new
   * next_wager_currency. Do not surface the insufficient-funds banner.
   *
   * @generated from enum value: PLAYER_WAGER_CURRENCY_UNAVAILABLE = 28;
   */
  PLAYER_WAGER_CURRENCY_UNAVAILABLE = 28,
}

/**
 * Describes the enum evenplay.bay_session.v1.PlayerStateReason.
 */
export const PlayerStateReasonSchema: GenEnum<PlayerStateReason> = /*@__PURE__*/
  enumDesc(file_bay_session, 1);

